.channelNameColumn {
  max-width: 400px;
}

.channelDescription {
  font-size: 12px;
}

.transcriptionMode {
  display: flex;
  align-items: center;
}

.transcriptionModeIcon {
  margin-right: 0.3rem;
}

.cover {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 4px;
}
